<template>
  <div class="content">
    <QA :loading.sync="loading" :qidList="qidList" :isEnd="isEnd" :selectedQidSmall="selectedQidSmall"></QA>
  </div>
</template>

<script>
import QA from '../components/Q&A.vue';
import { answerUpload } from '@/services/exam'

export default {
  components: {
    QA
  },
  data() {
    return {
      qidList: [
        {
          qid: 1,
          // title: '题目1',
          small: [
            {
              id: 1,
              title: '题目1',
              desc: ['1. 从资料1看，欧盟境内新能源产业发展迅速最主要的原因是（单选）：'],
              durationTime: 100,
              stemContent: [
                {
                  type: 'text',
                  value: '我们的生活每一天都离不开能源。但从2021年开始，欧洲却爆发了一次大规模的能源危机。这次危机暴露了欧洲能源发展中的哪些问题，又对我们有什么启示呢？几位同学围绕这一问题展开了探究。请你跟随这些同学，开始一次研究历程吧！'
                },
                {
                  type: 'text',
                  value: '围绕欧洲能源问题，同学们找到了资料1。'
                },
                {
                  type: 'textArray',
                  label: '资料1',
                  value: [
                    // { text: '都江堰主要工程变化大事年表' },
                    { text: '欧洲煤炭、石油、天然气等传统能源的储量十分有限且分布不均衡，很多国家主要是靠进口。所以在20世纪70年代爆发的两次全球性能源危机中，欧洲国家受到的影响最深。时至今日，欧盟国家仍未完全打破传统能源短缺的困局。为了解决这一问题，近20年来，欧盟境内的新能源产业发展非常迅速。' },
                    { text: '摘编自：《欧洲蓝皮书：欧洲发展报告（2013～2014）》，2014', textAlign: 'right', type: 'abstract' },
                  ]
                },
              ],
              askList: [
                {
                  id: 1,
                  type: 5,
                  answerList: [],
                  value: [
                    {
                      type: 'text',
                      val: 'A.石油储量有限',
                      clickStats: 'click_option_a#点击选项A',
                    },
                    {
                      type: 'text',
                      val: 'B.新能源是未来社会发展趋势',
                      clickStats: 'click_option_b#点击选项B',
                    },
                    {
                      type: 'text',
                      val: 'C.传统能源短缺',
                      clickStats: 'click_option_c#点击选项C',
                    },
                    {
                      type: 'text',
                      val: 'D.传统能源污染环境',
                      clickStats: 'click_option_d#点击选项D',
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          qid: 2,
          // title: '题目2',
          small: [
            {
              id: 2,
              title: '题目2',
              durationTime: 100,
              desc: [
                '<p style="text-indent: 0em;font-weight:bold">阅读资料后，小刚提出：</p>',
                '<p style="font-family: 楷体">受恶劣气候的影响，欧洲许多地区遭受了干旱、洪涝等自然灾害。这导致传统能源的产量大大减少，造成了欧洲能源短缺。一旦气候恢复正常，欧洲的能源危机问题会很快得到缓解。</p>',
                '<p style="height: 20px"></p>',
                '2. 小刚的说法中有哪些不恰当的地方？请你写在下面，并简单说明为什么。',
              ],
              stemContent: [
                {
                  type: 'text',
                  value: '小刚在研究过程中找到了资料2和资料3。'
                },
                {
                  type: 'textArray',
                  label: '资料2',
                  value: [
                    { text: '经历去年漫长寒冬，再迎今年高热酷暑，欧洲能源储备水平降至历史低位。欧洲天然气基础设施协会数据显示，当前欧洲区域性天然气库存仅为满负荷水平的74.7%，为10多年来最低水平，冬季能源储备亟待补充。' },
                    // { img: require('@/assets/exam/37.png') },
                    { text: '摘编自：新华社网站，2021年10月11日', textAlign: 'right', type: 'abstract' },
                  ]
                },
                {
                  type: 'textArray',
                  label: '资料3',
                  value: [
                    { text: '2022年的夏天对于欧洲国家来说，过得尤为艰难。不仅经历了“有气象记录以来最热的三个7月之一”，还可能遭遇“约500年来最严重干旱”。欧洲干旱观测站(EDO)的最新数据显示，7月中下旬，欧盟47%的地区处于“警告”状态，17%的土地因干旱进入最高等级的“警戒”状态。' },
                    { text: '伴随旱灾持续加重，各国以水资源为基础的能源利用也先后遭遇困境，这使欧洲能源危机更加雪上加霜。作为欧洲经济“生命线”的莱茵河，眼下水位已经降低至接近断航。低水位不仅将影响德国两大燃煤电厂未来一个月的产量，还将对煤炭、石油等的运输带来压力。' },
                    // { img: require('@/assets/exam/37.png') },
                    { text: '摘编自：中国新闻网，2022年8月12日', textAlign: 'right', type: 'abstract' },
                  ]
                },
              ],
              askList: [
                {
                  id: 2,
                  type: 1,
                  title: ''
                }
              ]
            }
          ]
        },
        {
          qid: 3,
          // title: '题目3',
          small: [
            {
              id: 3,
              title: '题目3',
              durationTime: 100,
              desc: ['3. 随着研究的深入，同学们发现，欧洲能源危机问题的产生是一个复杂的问题。请你结合资料1-4，分析欧洲出现能源危机问题的原因。'],
              stemContent: [
                {
                  type: 'textArray',
                  label: '资料4',
                  value: [
                    { text: '在欧盟国家一次能源结构中，石油和天然气占比约为60%，且主要依赖进口。欧盟进口天然气中约40%、进口原油中约30%来自俄罗斯。有数据显示，芬兰、拉脱维亚、波黑、摩尔多瓦等国进口天然气中，俄天然气占比超过90%。另外，保加利亚接近80%、德国、意大利和波兰超过40%、法国接近25%的天然气也从俄罗斯进口。' },
                    { text: '今日俄罗斯网站援引相关数据报道，截至今年1月12日，欧洲天然气库存已经不到全部储存设施容量的一半。德国媒体报道，德国天然气库存处于“稀缺水平”。' },
                    { text: '摘编自：新华社网站，2022年3月1日', textAlign: 'right', type: 'abstract' },
                  ]
                },
              ],
              askList: [
                {
                  id: 1,
                  type: 1
                }
              ]
            },
          ]
        },
        {
          qid: 4,
          // title: '题目4',
          small: [
            {
              id: 4,
              title: '题目4',
              showAnswer: false,
              durationTime: 100,
              desc: ['4. 在能源危机愈演愈烈的背景下，未来是应该继续大力发展新能源，还是应该回到传统能源？说说你的观点，并结合资料说明理由。'],
              stemContent: [
                {
                  type: 'textArray',
                  label: '资料5',
                  value: [
                    // { text: '都江堰主要工程变化大事年表' },
                    { text: '欧盟：可再生能源2030年消费量占比要达到45%！', type: 'title' },
                    { text: '2022年9月13日，欧盟议会通过了可再生能源发展法案（Renewable Energy Directive，REDII），将2030年可再生能源发展目标提升至终端能源占比45%！' },
                    { text: '2021年下半年以来，能源供应问题日益严重。为了加快2030年前摆脱对进口化石能源依赖，同时保证经济从新冠疫情中恢复，欧洲依然牢牢擎住了可再生能源发展的大旗，将加快可再生能源的替代步伐作为最主要的出路。' },
                    { text: '摘编自：《中国能源报》，2022年9月17日', textAlign: 'right' }
                  ]
                },
                {
                  type: 'textArray',
                  label: '资料6',
                  value: [
                    {
                      type: 'video',
                      id: 1,
                      value: [
                        {
                          isControl: true,
                          autoPlay: false,
                          isloop: false,
                          isImg: true,
                          url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/bjesr/video/energy_4_6.mp4'
                        }
                      ]
                    }
                  ]
                },
                {
                  type: 'textArray',
                  label: '资料7',
                  value: [
                    { img: require('@/assets/exam/22-energy-vs.png') },
                    { text: '[根据有关资料编写]', textAlign: 'right' },
                  ]
                },
              ],
              askList: [
                {
                  id: 1,
                  type: 1
                }
              ]
            },
          // {
          //   id: 5,
          //   title: '题目5',
          //   durationTime: 100,
          //   desc: [],
          //   stemContent: [],
          //   askList: []
          // },
          ]
        },
        {
          qid: 5,
          // title: '题目5',
          small: [
            {
              id: 5,
              title: '题目5',
              durationTime: 100,
              desc: ['5. 针对倡议中提出的几点做法，你认为存在哪些问题，请帮助同学们修改并完善。'],
              stemContent: [
                {
                  type: 'text',
                  value: '通过能源问题研究，同学们打算在学校宣传栏贴出下面的《节约能源倡议书》。'
                },
                {
                  type: 'image',
                  value: require('@/assets/exam/energy-propose.png'),
                  // isBig: true,
                }
              ],
              // contentWidth: '8.5%',
              // askWidth: '91.5%',
              askList: [
                {
                  id: 1,
                  type: 1,
                  title: ''
                }
              ]
            },
          ]
        }
      ],
      isEnd: false,
      loading: false,
      selectedQidSmall: 1
    }
  },
  methods: {
    async next(sonData, currentQSmall, type) {
      const data = Object.assign({
        exam_id: 1,
        exam_num: '1_' + currentQSmall,
        subject_id: 10,
        subject_name: '能源',
        pic_info: '答案',
        status: 2
      }, sonData)
      if (this.selectedQidSmall > 0 && !this.isEnd) {
        const res = await answerUpload(data)
        this.loading = false
        if (!res || res.code != '200') {
          this.$message({ type: 'error', message: res ? res.msg || res.message : '网络连接失败！' })
          return
        }
      }
      if (type === 'overTime' || this.isEnd) {
        this.nextPage(type === 'overTime')
      } else if (currentQSmall === 5) {
        this.selectedQidSmall = 5
        this.isEnd = true
      } else {
        this.selectedQidSmall = currentQSmall + 1
      }
      this.$forceUpdate()
    },
    nextPage(isEnd) {
      // setTimeout(() => {
      const examArr = JSON.parse(sessionStorage.currentExamGroup).exam
      if (isEnd) {
        this.$message.info('测评结束')
        if (examArr.length === 1) {
          this.$router.push({
            name: 'examLogin',
            query: {
              subject: 'criticismSteer',
              type: 'public',
              isEnd: true
            }
          })
        } else {
          this.$router.push({
            name: 'examLogin',
            query: {
              isEnd: true,
              subject: sessionStorage.subjectName,
              time: JSON.parse(sessionStorage.currentExamGroup).name.includes('下午') ? 'pm' : undefined
            }
          })
        }
      } else {
        sessionStorage.currentExamIndex = Number(sessionStorage.currentExamIndex) + 1
        this.$router.push({
          name: examArr[sessionStorage.currentExamIndex]
        })
      }
    }
  },
}
</script>

<style lang="less">
.content{
  height: 100%;
}
</style>
